import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import CustomLabel from "../components/profile/CustomLabel";
import VenueAreasContainer from "../components/venueAreas/VenueAreasContainer";
import { AlertStatusCard } from "../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import { IMateriaulGridOps } from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";


import Styles from "../scss/formFields.module.scss";
import FormSwitchWithText from "../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";


export const CollectionCustomLabel: IDynamicFormRow[] = [
  {
    label: "forms.orders.tableService",
    keyName: "table_enabled",
    Component: () => <CustomLabel type='COLLECTION' />,
  },
];
export const DeliveryCustomLabel: IDynamicFormRow[] = [
  {
    label: "forms.orders.tableService",
    keyName: "table_enabled",
    Component: () => <CustomLabel type='DELIVERY' />,
  },
];
export const DineInCustomLabel: IDynamicFormRow[] = [
  {
    label: "forms.orders.tableService",
    keyName: "table_enabled",
    Component: () => <CustomLabel type='DINE-IN' />,
  },
];
export const VenueAreaRanges: IDynamicFormRow[] = [
  {
    label: 'forms.settings.VenueAreaRanges',
    keyName: 'table_layout',
    Component: VenueAreasContainer,
    className: Styles.tableRangeArea,
    formProps: {
      buttonLabel:"merchant.buttons.createNewVenueArea",
      secondLabel: "forms.settings.venueAreas",
      message: "forms.settings.emptyVenueAreas"
    },
  },
];
export const PickupCustomLabel: IDynamicFormRow[] = [
  {
    label: "forms.orders.tableService",
    keyName: "table_enabled",
    Component: () => <CustomLabel type='PICKUP-NOW' />,
  },
];

export function MultiVendorOrdering(t:(key:string)=>string): IDynamicFormRow[]{
  return [
    {
      label: "groups.form.enableMultiVendorOrdering",
      keyName: "multi_ordering_enabled",
      Component: FormSwitchWithText,
      className: Styles.EnableFormEntity,
      formProps: {
        secondLabel: "groups.form.multiVendorSubTitle",
        hasStatus: true
      },
    },
    {
      label:'',
      keyName:'',
      Component: AlertStatusCard,
      gridColumnOptions: { formCol: 12 as IMateriaulGridOps },
      formProps:{
        alertProps:{severity: "info"},
        alertMessage:
          <>
            {t("groups.form.multiVendorSwitchInfo")}
          </>
    }}
]}
